import { render, staticRenderFns } from "./basicSetting.vue?vue&type=template&id=47b66434&scoped=true&"
import script from "./basicSetting.vue?vue&type=script&lang=js&"
export * from "./basicSetting.vue?vue&type=script&lang=js&"
import style0 from "./basicSetting.vue?vue&type=style&index=0&id=47b66434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b66434",
  null
  
)

export default component.exports